import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M5.333 9.334a.5.5 0 0 1 .5-.5h3.333a.5.5 0 1 1 0 1H5.833a.5.5 0 0 1-.5-.5ZM5.833 10.834a.5.5 0 0 0 0 1h5.333a.5.5 0 0 0 0-1H5.833Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M13.166.833c.645 0 1.167.523 1.167 1.167v12c0 .645-.522 1.167-1.167 1.167H3.833A1.167 1.167 0 0 1 2.666 14V2c0-.644.523-1.167 1.167-1.167h9.334ZM3.666 2c0-.092.075-.167.167-.167h1.5v4.834a.5.5 0 0 0 .832.374l1.168-1.039 1.168 1.039a.5.5 0 0 0 .832-.374V1.834h3.833c.093 0 .167.074.167.166v12a.167.167 0 0 1-.167.167H3.833A.167.167 0 0 1 3.666 14V2Zm4.667-.167h-2v3.72l.668-.593a.5.5 0 0 1 .664 0l.668.593v-3.72Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }